
import React, { useEffect, useState } from "react";
import "./Address.css";
import { useNavigate } from "react-router-dom";



  function Address() {
    const [billingAddress, setBillingAddress] = useState("");
    const [shippingAddress, setShippingAddress] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
      const billingAddress = localStorage.getItem("billing_address");
      const shippingAddress = localStorage.getItem("shipping_address");
      if (billingAddress) {
        setBillingAddress(JSON.parse(billingAddress));
      }
      if (shippingAddress) {
        setShippingAddress(JSON.parse(shippingAddress));
      }
    },[])

  return (
    <div>
      <p>The following address will be used in the checkout page by default</p>

      <div className="address-main-container">
        <div className="address-container">
          <div>
            <h2>Billng Address</h2>
            <button onClick={() => navigate("/my-account/edit-billing-address") }>Edit</button>
          </div>
          <p>{billingAddress?.first_name} {billingAddress?.last_name} </p>
          <p>{billingAddress?.street_address}</p>
          <p>{billingAddress?.apartment}</p>
          <p>{billingAddress?.city} {billingAddress?.pincode}</p>
          <p>{billingAddress?.state}</p>
        </div>

        <div className="address-container">
        <div>
            <h2>Shipping Address</h2>
            <button onClick={() => navigate("/my-account/edit-shipping-address") }>Edit</button>
          </div>
          <p>{shippingAddress?.first_name} {shippingAddress?.last_name}</p>
          <p>{shippingAddress?.street_address}</p>
          <p>{shippingAddress?.apartment}</p>
          <p>{shippingAddress?.city} {shippingAddress?.pincode}</p>
          <p>{shippingAddress?.state}</p>
        </div>
      </div>
    </div>
  );
}

export default Address;